<div class="h-100 w-100 m-0 row bg-custom-primary">
    <div class="col-md-7 flex flex-row-1 form-container px-4 py-3">
        <div class="h-100">
            <div class="d-flex justify-content-between">
                <div class="logo">
                    <img [src]="cvaUI_url+ '/assets/images/logo.svg'" alt="logo" width="70px">
                </div>
            </div>
            <div
                class="d-flex justify-content-center align-items-center bg-custom-primary p-4 position-relative height-90">
                <div class="fp-form">
                    <div class="d-flex justify-content-center mb-4">
                        <img [src]="cvaUI_url+ '/assets/images/key.png'" alt="key img" width="110px" />
                    </div>
                    <div class="text-center">
                        <h2 class="mb-3">Forgot Password</h2>
                        <p>Enter registered email ID.</p>
                    </div>
                    <div class="mt-3">
                        <div class="">
                            <form [formGroup]="fpForm" (ngSubmit)="submitForm()" class="login-form">
                                <mat-form-field appearance="outline" class="w-100 mt-3">
                                    <mat-label>Email</mat-label>
                                    <input type="text" matInput placeholder="" formControlName="email">
                                    <mat-error
                                        *ngIf="fpForm.get('email')?.dirty && fpForm.get('email')?.hasError('email')">Email
                                        is
                                        Invalid</mat-error>
                                    <mat-error
                                        *ngIf="fpForm.get('email')?.dirty && fpForm.get('email')?.hasError('required')">Email
                                        is required</mat-error>

                                </mat-form-field>
                                <mat-error class="custom-err" *ngIf="showErrMsg">
                                    {{showErrMsg}}
                                </mat-error>
                                <div class="mt-3">
                                    <button class="form-btn" mat-stroked-button size="large"
                                        type="submit">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="position-absolute bottom-0 text-center m-auto start-0 end-0 mb-2">
                    Remember password? <span class="text-secondary cursor-pointer"
                        [routerLink]="['/'+routes_constants.LOGIN]">Login</span>
                </div>
            </div>

        </div>
    </div>
    <div class="h-100 col-md-5 p-0 bg-cover position-relative bg-co d-none d-md-block">
        <cva-form-template></cva-form-template>
    </div>
</div>